import { Theme } from '@material-ui/core';
import { CSSProperties } from '@material-ui/core/styles/withStyles';
import { BRAND } from 'theme';

/** Общее для карточек главной: скругление, тени, подъём при наведении, кольцо фокуса, кнопка-пилюля. */
export const CARD_RADIUS = 28;

export const SHADOW = {
  lift: '0 16px 40px rgba(26, 26, 81, 0.12)',
  featured: '0 20px 48px rgba(26, 26, 81, 0.24)',
  featuredLift: '0 28px 56px rgba(26, 26, 81, 0.3)',
};

export const ARROW_NUDGE: CSSProperties = { transform: 'translateX(4px)' };

export const nudgeTransition = (theme: Theme): CSSProperties => ({
  transition: theme.transitions.create('transform', { duration: theme.transitions.duration.short }),
});

export const cardSurface = (theme: Theme): CSSProperties => ({
  width: '100%',
  height: '100%',
  font: 'inherit',
  textAlign: 'left',
  borderRadius: CARD_RADIUS,
  transition: theme.transitions.create(['transform', 'box-shadow', 'border-color'], {
    duration: theme.transitions.duration.short,
  }),
  '&.Mui-focusVisible': {
    outline: `3px solid ${BRAND.accent}`,
    outlineOffset: 3,
  },
});

export const lightCard = (theme: Theme): CSSProperties => ({
  ...cardSurface(theme),
  backgroundColor: theme.palette.common.white,
  border: `1px solid ${BRAND.line}`,
  '&:hover, &.Mui-focusVisible': {
    transform: 'translateY(-2px)',
    boxShadow: SHADOW.lift,
    borderColor: BRAND.sky,
  },
});

/** Раскладка акцентной карточки: текст сверху, кнопка снизу, иллюстрация абсолютом справа. */
export const featuredLayout = (theme: Theme): CSSProperties => ({
  position: 'relative',
  overflow: 'hidden',
  minHeight: 280,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: theme.spacing(3),
  padding: theme.spacing(4, 5),
});

export const actionPill = (theme: Theme): CSSProperties => ({
  position: 'relative',
  display: 'inline-flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  padding: theme.spacing(1.5, 3),
  borderRadius: 999,
  fontWeight: 600,
});
